module.exports = __webpack_public_path__ + "img/car_4.3d49dd97.png";